<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="title">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
      <FormItem label="所属系统" prop="appSystem">
        <sl-select :disabled="!!form.id" value-type="string" v-model="form.appSystem" dict="$appSystem" :clearable="true"></sl-select>
      </FormItem>
      <FormItem label="角色名称" prop="name">
        <Input v-model="form.name"></Input>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" v-model="form.remark"></Input>
      </FormItem>
      <FormItem label="角色授权" prop="menus">
        <sl-auth-tree ref="authTree" :checked-keys="form.menus"></sl-auth-tree>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur,change' },
        ],
      },
      form: {
        id: null,
        name: null,
        appSystem:null,
        menus: [],
        remark: null
      },
      loading:false,
      modalVisible:false,
    }
  },

  computed:{
    title(){
      return this.form.id ? '修改角色' : '新增角色'
    }
  },
  
  created() {
    this.def = { ...this.form }
  },

  methods: {
    query(id) {
      this.$refs['form'].resetFields()
      this.form.id = id
      this.modalVisible = true
      if(id){
        this.$request.role(id).then(resp => {
          this.$utils.fill(this.form, resp.data)
          this.form.menus = (resp.data.menus || [] ).map(i => i.id)
        })
      }else{
        this.$utils.fill(this.form,this.ref)
        this.form.menus = []
      }
    },

    save() {
      //
      let params = { ...this.form }
      params.menus = this.$refs.authTree.getChecked()

      this.loading = true
      let promise = this.form.id ? this.$request.roleUpdate : this.$request.roleCreate
      promise(params).then(resp => {
        
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')

          if(!this.form.id){
            this.modalVisible = false
          }
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
  }
}
</script>